import { PageListDataSource } from './BaseDataSources';
import { ICountry } from '../Interfaces';

export class OrganizationCountrySource extends PageListDataSource<ICountry> {
  public constructor() {
    super('/datasource/organizationcountries');
  }
}
